import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const ClubListPage = () =>
  import('@modules/club/components/club-list-page.vue');
const ClubFormPage = () =>
  import('@modules/club/components/club-form-page.vue');
const ClubViewPage = () =>
  import('@modules/club/components/club-view-page.vue');
const ClubImporterPage = () =>
  import('@modules/club/components/club-importer-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'club',
        path: '/club',
        component: ClubListPage,
        meta: {
          auth: true,
          permission: Permissions.values.clubView,
        },
      },
      {
        name: 'clubNew',
        path: '/club/new',
        component: ClubFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.clubCreate,
        },
      },
      {
        name: 'clubImporter',
        path: '/club/import',
        component: ClubImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.clubImport,
        },
      },
      {
        name: 'clubEdit',
        path: '/club/:id/edit',
        component: ClubFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.clubEdit,
        },
        props: true,
      },
      {
        name: 'clubView',
        path: '/club/:id',
        component: ClubViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.clubView,
        },
        props: true,
      },
    ],
  },
];
